import { compose, curry, propEq, propOr, find } from 'ramda';

export const getZipCodeRules = curry((geographicArea, filters) =>
  compose(JSON.parse, propOr('true', 'AUTORISE'), find(propEq('NOM', geographicArea)))(filters)
);
